import "../chunk-D57E6H3M.mjs";

// src/hooks/useScrollEdges.ts
import * as React from "react";
function useScrollEdges(containerRef, targetRef = containerRef) {
  React.useEffect(() => {
    const container = containerRef.current;
    const target = targetRef.current;
    if (!container || !target) return;
    let rafId = null;
    const update = () => {
      rafId = null;
      const max = container.scrollWidth - container.clientWidth;
      const fromLeft = getComputedStyle(container).direction === "rtl" ? max + container.scrollLeft : container.scrollLeft;
      target.setAttribute("data-can-scroll-left", String(fromLeft > 1));
      target.setAttribute("data-can-scroll-right", String(fromLeft < max - 1));
    };
    const scheduleUpdate = () => {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(update);
    };
    scheduleUpdate();
    const resizeObserver = new ResizeObserver(scheduleUpdate);
    resizeObserver.observe(container);
    if (container.firstElementChild) {
      resizeObserver.observe(container.firstElementChild);
    }
    container.addEventListener("scroll", scheduleUpdate, { passive: true });
    return () => {
      if (rafId !== null) cancelAnimationFrame(rafId);
      resizeObserver.disconnect();
      container.removeEventListener("scroll", scheduleUpdate);
    };
  }, [containerRef, targetRef]);
}
export {
  useScrollEdges
};
//# sourceMappingURL=useScrollEdges.mjs.map